angular.module('task-project')
    .component('taskProjectGroupBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<',
            btnXs: '<',
            onDeleted: '&'
        },
        templateUrl: "app/task/task-project-group/btn-options.html",
        controller: function ($rootScope, TaskProjectGroup, TaskProjectGroupService) {
            this.TaskProjectGroupService = TaskProjectGroupService

            this.execute0nDeleted = this.onDeleted || angular.noop;

            this.add = () => TaskProjectGroupService.add()
            this.show = () => TaskProjectGroupService.show(this.item.id)
            this.edit = () => TaskProjectGroupService.edit(this.item.id)

            this.delete = () => TaskProjectGroupService.delete(this.item)
        }
    })
